function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M360.233,121.189c11.046,0,20-8.954,20-20V49.378C380.233,22.151,357.837,0,330.31,0H90.923C63.396,0,41,22.151,41,49.378 v413.244C41,489.849,63.396,512,90.923,512H330.31c27.527,0,49.923-22.151,49.923-49.378v-51.811c0-11.045-8.955-19.999-20-19.999 c-11.046,0-20,8.954-20,20v51.811c0,5.171-4.451,9.378-9.923,9.378H90.923c-5.472,0-9.923-4.207-9.923-9.378V49.378 C81,44.207,85.451,40,90.923,40H330.31c5.472,0,9.923,4.207,9.923,9.378v51.811C340.233,112.235,349.187,121.189,360.233,121.189z "
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M464.963,241.682L358.521,137.881c-7.908-7.713-20.571-7.554-28.281,0.355c-7.712,7.907-7.553,20.57,0.355,28.281 L401.845,236H210.616c-11.046,0-20,8.954-20,20s8.954,20,20,20h191.229l-71.25,69.482c-7.908,7.711-8.067,20.374-0.355,28.281 c7.709,7.907,20.373,8.07,28.281,0.355l106.442-103.801C473.061,262.436,472.963,249.469,464.963,241.682z"
})));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.ba6c76ac.svg";
export { ForwardRef as ReactComponent };